Vue.component('left-navigation', require('./components/leftNavigation.vue').default);
Vue.component('main-header', require('./components/mainHeader.vue').default);
Vue.component('main-body', require('./components/mainBody.vue').default);
Vue.component('main-footer', require('./components/mainFooter.vue').default);
Vue.component('aw-contents', require('./components/AWContents.vue').default);
//contents type
Vue.component('aw-intro', require('./components/types/intro.vue').default);
Vue.component('aw-outro', require('./components/types/outro.vue').default);
Vue.component('aw-plan', require('./components/types/plan.vue').default);
Vue.component('aw-lesson', require('./components/types/lesson.vue').default);
Vue.component('aw-opinion', require('./components/types/opinion.vue').default);
Vue.component('aw-summary', require('./components/types/summary.vue').default);
Vue.component('aw-supplementary', require('./components/types/supplementary.vue').default);

//quiz
Vue.component('aw-quiz', require('./components/types/quiz.vue').default);
Vue.component('aw-exercise', require('./components/types/exercise.vue').default);
Vue.component('aw-multiple-quiz', require('./components/types/multipleQuiz.vue').default);
Vue.component('aw-short-answer-quiz', require('./components/types/shortAnswer.vue').default);
Vue.component('aw-ox-quiz', require('./components/types/oxQuiz.vue').default);
Vue.component('aw-quiz-result', require('./components/types/quizResult.vue').default);


//pre test
Vue.component('aw-pre-test', require('./components/types/preTest.vue').default);
Vue.component('aw-pre-test-gate', require('./components/types/preTestGate.vue').default);
Vue.component('aw-pre-test-body', require('./components/types/preTestBody.vue').default);
Vue.component('aw-pre-test-result', require('./components/types/preTestResult.vue').default);


//memo
Vue.component('memo-create', require('./components/types/memoCreate.vue').default);
Vue.component('memo-update', require('./components/types/memoUpdate.vue').default);
Vue.component('memo-list', require('./components/types/memoList.vue').default);